import {SlotGame} from "@nolimitcity/slot-game/bin/SlotGame";
import {gsap} from "gsap";
import {SoundConfig} from "./SoundConfig";
import {INolimitAudioPlayer} from "@nolimitcity/slot-audio/bin/INolimitAudioPlayer";
import {NolimitHowl} from "@nolimitcity/slot-audio/bin/NolimitHowl";
import {ArrayHelper} from '../../core/utils/ArrayHelper';
import {Logger} from "@nolimitcity/slot-launcher/bin/utils/Logger";
import {PRGameMode} from "../server/PRGameMode";
import {GameSetting} from "../../core/setting/GameSetting";

export class SoundManager {

    protected static currentLoop: string[] = [""];
    private static currentBigWin: string = "";

    private static standardVolume = 1;
    private static deadVolume = 0.35;

    private static fsIntroClicked: boolean = false;

    private static feelVolume = 0.5;
    private static feelLevel = 0;

    private static currentAmbientLoopName: string = "";
    private static tlCounter: gsap.core.Timeline;
    private static playMainLoop2: boolean = false;
    private static mainLoopCrossFadeTimeline: gsap.core.Timeline= gsap.timeline();

    private static PanningForStop: number[] = [0, 0, 0, 0, 0];

    private static _xWildLanded:boolean= false;
    private static _xWaysLanded:boolean= false;
    private static _wildLanded:boolean= false;
    private static _xWildFusePlayed:boolean= false;
    private static _wildTriggerId:number= 0;
    public static get soundPlayer(): INolimitAudioPlayer {
        return <INolimitAudioPlayer>SlotGame.sound;
    }

    public static playReelStop(reelID: number, anticipation: boolean = false): void {
        const soundName: string = anticipation ? SoundConfig.SCATTER_LAND[reelID] : SoundConfig.REELS_DEFAULT_STOP[reelID];// + (reelID + 1);
        const sound: NolimitHowl | undefined = this.soundPlayer.fetchSoundPlayer(soundName)
        if (sound) sound.player.stereo(this.PanningForStop[reelID]);
        this.soundPlayer.stopTrack(soundName);
        this.soundPlayer.playTrack({name: soundName});
    }

    public static crossFadeToMain2(fadeDuration:number = 1, fromBigWin:boolean = false) {
        if(fromBigWin){
            this.soundPlayer.fadeTrack({name: this.currentAmbientLoopName, to: 0, duration: 5000});
            this.currentAmbientLoopName = SoundConfig.GAME_MAIN_AMBIANCE;
        }
        if (this.currentAmbientLoopName === SoundConfig.GAME_MAIN_AMBIANCE) {
            this.soundPlayer.fadeTrack({name: this.currentAmbientLoopName, to: 0, duration: fadeDuration});
            this.currentAmbientLoopName = SoundConfig.GAME_MAIN_AMBIANCE2;
            this.soundPlayer.fadeTrack({name: this.currentAmbientLoopName, to: 1, duration: fadeDuration});
            Logger.logDev("sound:" + this.currentAmbientLoopName);
        }
        if(this.currentAmbientLoopName && this.currentAmbientLoopName[0] === "f"){
            this.playMainLoop2 = false;
            return;
        }
        this.playMainLoop2 = true;

        SoundManager.mainLoopCrossFadeTimeline.clear();
        SoundManager.mainLoopCrossFadeTimeline.add(() => {
            if (this.currentAmbientLoopName === SoundConfig.GAME_MAIN_AMBIANCE2) {
                this.soundPlayer.fadeTrack({name: this.currentAmbientLoopName, to: 0, duration: 5000});
                this.currentAmbientLoopName = SoundConfig.GAME_MAIN_AMBIANCE;
                this.soundPlayer.fadeTrack({name: this.currentAmbientLoopName, to: 1, duration: 5000});
                Logger.logDev("sound:" + this.currentAmbientLoopName);
            }
            this.playMainLoop2 = false;
        }, '<15');
    }

    public static setMainToMain1() {
        this.playMainLoop2 = false;
    }

    public static stopMainAmbiance(): void {
        this.playMainLoop2 = false;
        this.soundPlayer.stopTrack(SoundConfig.GAME_MAIN_AMBIANCE);
        this.soundPlayer.stopTrack(SoundConfig.GAME_MAIN_AMBIANCE2);
    }

    // #244
    public static stopBonusTypeAmbiance(): void {
        SoundConfig.FS_GAME_AMBIANCE.forEach((fsName: string) => {
            this.soundPlayer.stopTrack(fsName);
        });
    }

    public static playAmbientLoop(mode: string, duration: number = 200): void {
        this.playMainLoop2 = mode[0] === "R";
        const bonusType:number = (mode === PRGameMode.FREESPIN_LEVEL_ONE ? 0 : (mode === PRGameMode.FREESPIN_LEVEL_TWO ? 1 : 2));

        let name: string = (mode[0] === "F"?SoundConfig.FS_GAME_AMBIANCE[bonusType]:(mode[0] === "R"?SoundConfig.GAME_MAIN_AMBIANCE2:SoundConfig.GAME_MAIN_AMBIANCE));
        if (this.currentAmbientLoopName === name) {
            return;
        }
        this.stopAmbientLoop();
        this.currentAmbientLoopName = name;
        if (name[0] == "m") {
            this.soundPlayer.playTrack({name:SoundConfig.GAME_MAIN_AMBIANCE,volume: this.playMainLoop2 ? 0 : 1});
            this.soundPlayer.playTrack({name:SoundConfig.GAME_MAIN_AMBIANCE2, volume:this.playMainLoop2 ? 1 : 0});
        } else {
            this.soundPlayer.playTrack({name:name, volume:1});
        }
        Logger.logDev("sound:" + name);
    }

    public static stopAmbientLoop(): void {
        if (this.currentAmbientLoopName) {
            if (this.currentAmbientLoopName[0] == "m") {
                this.soundPlayer.stopTrack(SoundConfig.GAME_MAIN_AMBIANCE);
                this.soundPlayer.stopTrack(SoundConfig.GAME_MAIN_AMBIANCE2);
            } else {
                this.soundPlayer.stopTrack(this.currentAmbientLoopName);
            }
        }
    }

    // Please NOTE the duration is in millisecond!
    public static fadeAmbienceLoop(volume: number, duration: number): void {
        volume = volume == 0 ? 0.001 : volume;

        // #76
        if (SoundManager.mainLoopCrossFadeTimeline) {
            SoundManager.mainLoopCrossFadeTimeline.clear();
            SoundManager.mainLoopCrossFadeTimeline.kill();

            this.playMainLoop2 = false;
        }

        if (this.currentAmbientLoopName[0] == "m") {
            this.soundPlayer.fadeTrack({name:SoundConfig.GAME_MAIN_AMBIANCE, duration: duration, to: this.playMainLoop2?0:volume});
            this.soundPlayer.fadeTrack({name:SoundConfig.GAME_MAIN_AMBIANCE2, duration: duration, to: this.playMainLoop2?volume:0});
        }else{
            this.soundPlayer.fadeTrack({name: this.currentAmbientLoopName, duration: duration, to: volume});
        }
        Logger.logDev("play AmbienceLoop sound: " + this.currentAmbientLoopName);
    }

    public static playSoundEffect(name: string, repeat?: number, volume?: number): NolimitHowl | undefined {
        Logger.logDev("play sound: " + name);
        return this.soundPlayer.playTrack({
            name: name,
            repeat: repeat,
            volume: volume !== undefined ? volume : this.standardVolume
        });
    }

    public static playXWildLandingSound(isQuickStop:boolean): void {
       if(!(this._xWildLanded && (GameSetting.isFastSpin || isQuickStop))){
           this.playSoundEffect("xWildLanding")
       }
        this._xWildLanded = true;
    }

    public static playXWaysLandingSound(isQuickStop:boolean): void {
        if(!(this._xWaysLanded && (GameSetting.isFastSpin || isQuickStop))){
            this.playSoundEffect("xwaysLandning");
        }
        this._xWaysLanded = true;
    }

    public static playWildLandingSound(isQuickStop:boolean): void {
        if(!(this._wildLanded && (GameSetting.isFastSpin || isQuickStop))){
            this.playSoundEffect("wildLanding");
        }
        this._wildLanded = true;
    }

    public static playWildTransformSound(calledFromReSpinStart: boolean): void {
        if (!calledFromReSpinStart && GameSetting.isFastSpin) {
            return;
        }
        this.playSoundEffect(`wildExpand${this._wildTriggerId % 2 + 1}`);
        this._wildTriggerId++;
    }

    public static playWildFuseSound(): void {

       if(!this._xWildFusePlayed){
           this.playSoundEffect("xWildFuse", 100);
       }
        this._xWildFusePlayed = true;
    }

    public static stopWildFuseSound(): void {
        if(this._xWildFusePlayed){
            this._xWildFusePlayed = false;
            SoundManager.stopSoundEffect("xWildFuse");
        }
    }

    public static stopSoundEffect(name: string): void {
        Logger.logDev("stop sound: " + name);
        this.soundPlayer.stopTrack(name);
    }

    public static onFadeSoundEffect(name: string, volume: number, duration: number): void {
        Logger.logDev("fade sound: " + name);
        this.soundPlayer.fadeTrack({name: name, to: volume, duration: duration});
    }

    public static playScreenMusic(name:string, fadeDuration:number = 2): void {
        const tl = gsap.timeline();
        tl.add(() => {
            this.fadeAmbienceLoop(0, fadeDuration);

            this.currentAmbientLoopName = name;
            this.fadeAmbienceLoop(1, 0);
        });
    }

    public static reset(): void {
        this._xWildLanded= false;
        this._xWaysLanded= false;
        this._wildLanded= false;
        this._xWildFusePlayed= false;
        this._wildTriggerId= Math.floor(Math.random()*2);
    }

    public static playRespin(): void {
        //SoundManager.playAmbientLoop(SoundConfig.RESPIN_MUSIC);
    }

    public static playBonus(): void {
        //SoundManager.playAmbientLoop(SoundConfig.FS_GAME_AMBIANCE);
    }

    private static getFeelVolume(lvl: number): number {
        return 0.5 + lvl * 0.1;
    }

    public static setDeadSpinVolume(val: boolean) {
        this.standardVolume = val ? this.deadVolume : 1;
    }

    public static playScatterLand(lvl: number, dead: boolean): NolimitHowl | undefined {
        SoundConfig.SCATTER_LAND.forEach((soundName: string) => this.soundPlayer.stopTrack(soundName));
        return this.soundPlayer.playTrack({name: SoundConfig.SCATTER_LAND[lvl], volume: dead ? this.deadVolume : 1});
    }


    // private static respinType:number = 0;
    // public static playRespinSound(): NolimitHowl | undefined {
    //     const respinLoop:string = !this.respinType ? SoundConfig.RESPIN_ANTICIPATION : SoundConfig.RESPIN_ANTICIPATION_2;
    //     this.respinType = (this.respinType+1)%2;
    //     return this.soundPlayer.playTrack({
    //         name: respinLoop,
    //         repeat: 5,
    //         volume: 1
    //     });
    // }

    // public static stopRespinSound(): NolimitHowl | undefined {
    //     const respinLoop:string = this.respinType ? SoundConfig.RESPIN_ANTICIPATION : SoundConfig.RESPIN_ANTICIPATION_2;
    //     const endSound:string = this.respinType ? SoundConfig.RESPIN_ANTICIPATION_END : SoundConfig.RESPIN_ANTICIPATION_END_2;
    //     this.stopSoundEffect(respinLoop);

    //     return this.soundPlayer.playTrack({
    //         name: endSound,
    //         volume: 1
    //     });
    // }

    public static startAmbient(): void {
        this.currentLoop.forEach(loop => {
            this.soundPlayer.playTrack({name: loop, volume: 1, repeat: Number.MAX_SAFE_INTEGER});
        });
    }

    public static stopAmbient(): void {
        this.currentLoop.forEach(loop => {
            this.soundPlayer.stopTrack(loop);
        });
    }

    public static fadeOutAmbient(duration: number = 2000, volume: number = 0): void {
        this.currentLoop.forEach(loop => {
            this.soundPlayer.fadeTrack({name: loop, duration: duration, to: volume});
        });
    }

    public static fadeInAmbient(duration: number = 3000, volume: number = 1): void {
        this.currentLoop.forEach(loop => {
            this.soundPlayer.fadeTrack({
                name: loop,
                duration: duration,
                to: loop === SoundConfig.GAME_MAIN_AMBIANCE ? this.getFeelVolume(this.feelLevel) : volume
            });
        });
    }

    public static startNewFsMusic(intro: string, loop: string): void {
        this.ChangeToLoop([loop]);

        const p = this.soundPlayer.playTrack({name: intro})

        if (!p) {
            this.soundPlayer.stopTrack(intro);
            this.startAmbient();
        } else {
            p.player.loop(false);
            p.player.once("end", () => {
                this.startAmbient();
            })
        }
    }

    // public static playBigWin(lvl: number, skipped: boolean = false, repeats: boolean): void {

    //     const nextBigWinSound: string = SoundConfig.bigWinLoop(lvl);

    //     this.soundPlayer.stopTrack(this.currentBigWin);
    //     this.soundPlayer.stopTrack(SoundConfig.BIG_WIN_LVL_CHANGE)

    //     if(this.currentBigWin != nextBigWinSound && lvl != 1)
    //         this.playSoundEffect(SoundConfig.BIG_WIN_LVL_CHANGE)

    //     this.soundPlayer.playTrack({ name: nextBigWinSound, repeat: repeats ? Number.MAX_SAFE_INTEGER : 0 });

    //     this.currentBigWin = nextBigWinSound;
    // }

    public static fadeBigWin(durr: number): void {
        this.feelLevel = 4;
        this.soundPlayer.fadeTrack({name: this.currentBigWin, from: 1, to: 0, duration: durr});
    }

    public static stopBigWin(): void {
        this.soundPlayer.stopTrack(this.currentBigWin);
        this.currentBigWin = "";
    }

    // public static onBet(lvl?:number): void {
    //     this.tlCounter = Helper.setTimeline(this.tlCounter, new gsap.core.Timeline());

    //     this.soundPlayer.playTrack({ name: SoundConfig.MAIN_MUSIC, volume:this.getFeelVolume(this.feelLevel) });

    //     if(lvl != undefined && lvl){
    //         this.feelLevel = MathHelper.clamp(this.feelLevel + lvl, 0 , 4);
    //         this.soundPlayer.fadeTrack({name:SoundConfig.MAIN_MUSIC, to: this.getFeelVolume(this.feelLevel), duration:1e4 });
    //     }

    //     this.ApplyLoop(SoundConfig.MAIN_MUSIC);
    // }

    // public static onIdle(): void {
    //     this.tlCounter = Helper.setTimeline(this.tlCounter, new gsap.core.Timeline());
    //     if(this.soundPlayer.allPlayers()[0] && this.currentLoop.includes(SoundConfig.MAIN_MUSIC)){
    //         this.tlCounter.add(() => { 
    //             this.feelLevel = 0; 
    //             this.soundPlayer.fadeTrack({ name:SoundConfig.MAIN_MUSIC, from:undefined, to: 0, duration:2e4 })}, 10)
    //         this.tlCounter.add(() => {
    //             this.soundPlayer.stopTrack(SoundConfig.MAIN_MUSIC);
    //             this.RemoveLoop(SoundConfig.MAIN_MUSIC);
    //         }, 30)
    //     }
    // }

    // public static StartMainMusic(first?: boolean): void {
    //     this.soundPlayer.playTrack({ name: SoundConfig.MAIN_AMBIANCE });
    //     this.ApplyLoop(SoundConfig.MAIN_AMBIANCE);
    // }

    private static ApplyLoop(loop: string): void {
        if (!this.currentLoop.includes(loop)) this.currentLoop.push(loop);
    }

    public static ChangeToLoop(newLoop: string[]): void {
        this.emptyLoop();
        newLoop.forEach(l => this.ApplyLoop(l))
    }

    public static emptyLoop(): void {
        this.stopAmbient();
        while (this.currentLoop.length) this.RemoveLoop(this.currentLoop[0]);
    }

    private static RemoveLoop(loop: string): void {
        ArrayHelper.removeFirstMatchElement(this.currentLoop, loop);
    }

    public static OnEndFS(isSuper: boolean, wasGood: boolean): void {
    }

    public static StopAllSounds(): void {
        if (this.soundPlayer.allPlayers()[0]) // Loaded
            this.soundPlayer.allPlayers().forEach(p => {
                p.stop()
            });
    }

    // public static onEndClick(): void {
    //     this.playSoundEffect(SoundConfig.CONTINUE_AFTER_FS);
    //     this.StartMainMusic(false);
    // }

    public static fadeSound(name: string, from: number = 1, to: number, duration: number): void {
        this.soundPlayer.fadeTrack({
            name: name,
            duration: duration,
            from: from,
            to: to
        });
    }

    public static isSoundPlaying(soundName: string): boolean {
        return !!(this.soundPlayer.fetchSoundPlayer(soundName)?.isPlaying);
    }
}